module.exports = __webpack_public_path__ + "img/favorites.42236767.svg";